/*
 * Copyright (C) 2024 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and
 * should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly
 * prohibited.
 */

import styled from 'styled-components';
import appTheme from '../common/theme/appTheme.json';

export const StyledProvisioningPageSubheading = styled.h1`
  font-family: ${appTheme.viasatFontFamilyRegular};
  color: ${appTheme.primaryTextColor};
  font-weight: 400;
  font-size: 15px;
  letter-spacing: 0.2px;
  line-height: 24px;
  margin: 10px;
`;
